import style from "../style/Form.module.scss";

export default function Footnote() {
  return (
    <p className={style.footnote}>
      By creating an account, you agree to the{" "}
      <a href="https://tableflow.com/terms" target="_blank" rel="noreferrer noopener">
        Terms of Service
      </a>{" "}
      &{" "}
      <a href="https://tableflow.com/privacy" target="_blank" rel="noreferrer noopener">
        Privacy Policy
      </a>
    </p>
  );
}
